import React from 'react';

const RuleEngine: React.FC<{}> = () => {
	return <div />;
};

export default RuleEngine;
